import { Observable } from "rxjs/internal/Observable";
import { Result } from "../types/result";

export class FileDownloadEvent{
    constructor(
      public readonly periodOfReviewID: number,
      public readonly committeeName: string,
      public readonly timestamp: Date | null
    ){}

    public static fromJson(o: any): FileDownloadEvent {
      return new FileDownloadEvent(
          o.periodOfReviewID,
          o.committeeName,
          o.timestamp ? new Date(o.timestamp) : null
      );
  }
}

export abstract class FileDownloadMonitorService {
  public abstract saveFileDownloadEvent(committeeName:string, year:number): Promise<Result<string,string>>;
  public abstract getFileDownloadEvent(year:number, userId?:number): Observable<FileDownloadEvent[]>; 
}
